<template>
  <div>
    <div>
      <h2 class='text-jananavy-900 font-medium'><slot name='title' /></h2>
      <p class='font-light text-sm'><slot name='description' /></p>
    </div>
    <LoadingLayout :isLoading='isLoading' class='mt-8' :slownessThreshold='0'>
      <ReportNoDataWarning :warn='!view' :limitWidth='true'>
        <GraphStatCards :stats='view.stats' :isPrint='props.isPrint' />

        <div class='mt-8' :class='!props.isPrint ? "overflow-auto" : ""'>
          <table class='min-w-full 2xl:min-w-[80rem] table-fixed rounded-md force-rounded'>
            <thead class='bg-jananavy-900 text-white'>
              <tr>
                <th class='text-left font-medium px-4 py-2'>Email</th>
                <th class='text-left font-medium px-4 py-2'>Sub</th>
                <th class='text-left font-medium px-4 py-2'>First Access</th>
                <th class='text-left font-medium px-4 py-2'>Last Access</th>
                <th class='text-left font-medium px-4 py-2'>Sessions</th>
              </tr>
            </thead>
            <tbody class='divide-y border-b'>
              <tr v-for='user in view.users'>
                <td class='px-4 py-2 text-sm font-light bg-janaturq-100 sticky left-0'>
                  {{ user.email }}
                </td>
                <td class='whitespace-nowrap px-4 py-2 text-sm font-light bg-janaturq-100'>
                  {{ user.sub }}
                </td>
                <td class='whitespace-nowrap px-4 py-2 text-sm font-light bg-janaturq-100'>
                  {{ user.firstAccess ? (new Date(user.firstAccess)).toLocaleString() : '' }}
                </td>
                <td class='whitespace-nowrap px-4 py-2 text-sm font-light bg-janaturq-100'>
                  {{ user.lastAccess ? (new Date(user.lastAccess)).toLocaleString() : '' }}
                </td>
                <td class='whitespace-nowrap px-4 py-2 text-sm font-light bg-janaturq-100'>
                  {{ user.session.totalDocs }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <nav class="flex items-center justify-between bg-white mt-6 2xl:max-w-[80rem]" aria-label="Pagination">
          <div>
            <p class="text-sm text-gray-700">
              Page
              {{ ' ' }}
              <span class="font-medium">{{ request.getData()?.page }}</span>
              {{ ' ' }}
              of
              <span class="font-medium">{{ request.getData()?.totalPages }}</span>
            </p>
          </div>
          <div class="flex flex-1 justify-end">
            <button class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0" @click='prevPage' v-if='request.getData()?.hasPrevPage'>Previous</button>
            <button class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0" @click='nextPage' v-if='request.getData()?.hasNextPage'>Next</button>
          </div>
        </nav>
      </ReportNoDataWarning>
    </LoadingLayout>
  </div>
</template>

<script setup>

import { computed, watch, reactive } from 'vue';

import LoadingLayout from '@/components/layouts/loading-layout.vue';

import ReportNoDataWarning from '@/components/report/report-no-data-warning.vue';

import GraphStatCards from '@/components/reports/graphs/graph-stat-cards.vue';

import { usePayloadRequest } from '@/kernel/api';

const props = defineProps({
  isPrint: Boolean
});

const request = usePayloadRequest('GET', '/user/user-summaries');

const isLoading = computed(() => {
  return request.isLoading() || request.getData() === null;
});

const view = computed(() => {
  const data = request.getData();

  if (!data?.docs?.length) {
    return null;
  }

  return {
    users: data.docs,
    stats: [
    ]
  }
});

const prevPage = () => {
  request.doRequest({
    params: {
      page: request.getData()?.page - 1
    }
  });
}

const nextPage = () => {
  request.doRequest({
    params: {
      page: request.getData()?.page + 1
    }
  });
}

const load = () => {
  request.doRequest();
}

load();

</script>
